import React, { useCallback, useState } from 'react'
import { Badge, Button } from 'antd'

import { useGlobalShortcut } from 'admin/lib/shortcuts'
import { Matchers } from 'admin/lib/Records'
import { InternalNotesModal } from './InternalNotesModal'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { colours } from '@qflow/theme'

export const ViewInternalNotesButton: React.FC<{
  loaded: boolean
  record: any
}> = ({ loaded, record }) => {
  const [open, setOpen] = useState(false)

  const checkIfNotesExist = notes => {
    return notes != null && notes !== ''
  }

  useGlobalShortcut(
    Matchers.comments.add,
    useCallback(() => {
      setOpen(true)
    }, [])
  )

  return (
    <>
      <Badge
        size="default"
        count={
          checkIfNotesExist(record?.internalNotes) ? (
            <ExclamationCircleFilled style={{ color: colours.ERROR }} />
          ) : (
            0
          )
        }
      >
        <Button
          type="primary"
          disabled={!loaded}
          onClick={() => {
            setOpen(true)
          }}
        >
          {'Internal Notes'}
        </Button>
      </Badge>
      <InternalNotesModal open={open} onClose={() => setOpen(false)} />
    </>
  )
}
